export default "__VITE_ASSET__BCnmMyb7__"